<template>
  <div class="container">
    <h1 class="sr-only" v-html="'Gift Card Redemption'"></h1>
      <div class="logo-container">
          <img src="../assets/sample-logo.png" alt="" />
      </div>
      <div v-if="success" class="success-msg active">
          <img src="../assets/check-circle.png" alt=""/>
          <p id="success" class="fs2" v-html="challengeCodeLabel"></p>
      </div>
      <div id="error-msg-1" class="error-msg">
          <img src="../assets/exclamation-triangle.png" alt="" />
          <p id="error" v-html="errorMessage ? errorMessage : ''"></p>
      </div>
    <img class="brand-img" v-bind:src="rewardData.reward.image"  :alt="`Gift card: ${rewardData.reward.name}`"/>
      <h2>{{rewardData.reward.name}}</h2>
      <div aria-hidden="true" class="separator"></div>
      <div v-if="loading" class="spin-box">
          <div class="loader" title="0">
            <svg aria-hidden="true" version="1.1" id="loader-1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="120px" height="120px" viewBox="0 0 40 40" enable-background="new 0 0 40 40" xml:space="preserve">
              <path opacity="0.2" fill="#000" d="M20.201,5.169c-8.254,0-14.946,6.692-14.946,14.946c0,8.255,6.692,14.946,14.946,14.946
                s14.946-6.691,14.946-14.946C35.146,11.861,28.455,5.169,20.201,5.169z M20.201,31.749c-6.425,0-11.634-5.208-11.634-11.634
                c0-6.425,5.209-11.634,11.634-11.634c6.425,0,11.633,5.209,11.633,11.634C31.834,26.541,26.626,31.749,20.201,31.749z"></path>
              <path fill="#000" d="M26.013,10.047l1.654-2.866c-2.198-1.272-4.743-2.012-7.466-2.012h0v3.312h0
                C22.32,8.481,24.301,9.057,26.013,10.047z">
              <animateTransform attributeType="xml" attributeName="transform" type="rotate" from="0 20 20" to="360 20 20" dur="0.8s" repeatCount="indefinite"></animateTransform>
              </path>
            </svg>
          </div>
      </div>
      <div >
        <form method="post" id="withFormValidation">
          <button aria-describedby="status" ref="language"  @click.prevent="claimGift" class="button submit" v-html="'Claim your Gift'"></button>
        </form>
      </div>
    <span class="sr-only" id="status" aria-live="assertive" role="status" v-html="showLabel ? getStatusMessage : ''"></span>
  </div>
</template>

<script>
  import axios from 'axios'
  import { store } from '../../js/reactiveStates.js';
  export default {
    name: "page-2",
    props:{
      rewardData: Object
    },
    computed: {
      getStatusMessage(){
        if (this.success) {
          return this.challengeCodeLabel
        } else {
          return this.errorMessage
        }
      }
    },
    data: function(){
      return {
        showLabel: false,
        rewardDataLocal: this.rewardData,
        errorMessage: '',
        details:{},
        root:process.env.VUE_APP_SERVICE_URL,
        apiToken:'',
        success: true,
        loading: false,
        challengeCodeLabel : 'Challenge code accepted.',
        error: false,
        store
      }
    },
    mounted(){
      this.updateElText();
      this.$nextTick(() => {
        if (this.success) {
          setTimeout(() => {
            this.showLabel = true
          }, 800)
        }
      })
    },
    watch: {
      showLabel(val) {
        if (val) {
          setTimeout(() => {
            this.showLabel = false
          }, 2500)
        }
      },
      store: {
        handler(){
          this.updatePage();
        },
        deep: true
      }
    },
    methods:{
      claimGift(){
        this.loading = true;
        let body = {
          "challenge_code": store.challengeCode
        };
        let url = `${this.root}/grs/v1/redemption_link/${this.apiToken}/process?lang=`+store.chosenLanguage;

        axios.post(url, body)
          .then((resp) =>{
            if(resp.data.success === true ){
              this.details = resp.data.details;
               this.$emit('Details',resp.data);
              this.$router.push({path : '/page-3'});
            } else {
              this.success = false;
              this.error = true;
              if(this.rewardDataLocal.page_info.button_process && this.rewardDataLocal.page_info.button_process.length > 0){
                this.$refs.language.value = this.rewardDataLocal.page_info.button_process;
              }
              let errorMsgEl = document.getElementById('error-msg-1');
              this.errorMessage = resp.data.message;
              this.showLabel = true
              errorMsgEl.classList.add('active');
            }

          }).catch(err => {
          console.log(err)
        }).finally(() => {
          this.loading = false;
        })
      },
      updatePage(){
        let body = {
          "challenge_code" : store.challengeCode
        };

        let url = `${this.root}/grs/v1/redemption_link/${this.apiToken}/redeem?lang=`+store.chosenLanguage;
        axios.post(url,body).then((resp)=>{
          if(resp.data.success === true){
            this.rewardDataLocal.message = resp.data.message;
            this.rewardDataLocal.page_info = resp.data.page_info;
            this.$emit('rewardData', this.rewardDataLocal);
            this.updateElText();
          } else {
            this.errorMessage = resp.data.message;
            this.showLabel = true
            let errorMsgEl = document.getElementById('error-msg-1');
            errorMsgEl.classList.add('active');
          }
        }).catch((error) => {
          console.log('Error', error)
        })
      },
      updateElText(){
        this.apiToken = this.rewardDataLocal.redemption_link.api_token;
        if(this.rewardDataLocal.message && this.rewardDataLocal.message.length > 0){
          this.challengeCodeLabel = this.rewardDataLocal.message ;
        }
        if(this.rewardDataLocal.page_info.button_process && this.rewardDataLocal.page_info.button_process.length > 0){
          this.$refs.language.value = this.rewardDataLocal.page_info.button_process;
        }
      }
    }
  }
</script>
